import { ReactNode } from 'react';
import { Icon, IconType, modifiers, Size } from '@outdoria/ui';
import { CheckboxGroup } from './CheckboxGroup';
import { Image } from './Image';
import { Input } from './Input';
import { RadioGroup } from './RadioGroup';
import { Select } from './Select';
import { Switch } from './Switch';

import s from './Form.module.scss';

export const Form = ({
  children,
  icon,
  pretty,
  title,
}: {
  children: ReactNode;
  icon?: IconType;
  pretty?: boolean;
  title?: string;
}) => {
  const hasHeader = title || icon;
  return (
    <div className={modifiers(s, 'form', { pretty })}>
      {hasHeader && (
        <div className={s.form__header}>
          {icon && <Icon icon={icon} size={Size.SMALL} />}
          {title && <h3 className={s.form__title}>{title}</h3>}
        </div>
      )}

      {children}
    </div>
  );
};

Form.CheckboxGroup = CheckboxGroup;
Form.Image = Image;
Form.Input = Input;
Form.RadioGroup = RadioGroup;
Form.Select = Select;
Form.Switch = Switch;
